import React from "react";
import styles from './StyledPeriodButton.module.css';
import clsx from 'clsx'; // MUI classnames tool

const StyledPeriodButton = ({ text, onClick, disabled }) => {
  const isStart = /^d(é|e)but|d(é|e)marrer/i.test(text);
  const isEnd = /^fin|arr(ê|e)ter/i.test(text);

  // classname for button cicle position
  const circlePositionClass = isStart ? styles.circleLeft : isEnd ? styles.circleRight : styles.circleLeft;


  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={clsx(styles.button, circlePositionClass)}
    >
      <span>
        {text}
      </span>
    </button>
  );
};

export default StyledPeriodButton;
